import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import VideoPlayerIframe from './VideoPlayerIframe';

const DripLayout = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 768px) {
    padding-bottom: 40px;
  }
}
`;

const TitleArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const VideoArea = styled.div`
  width: 100%;
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    height: 100%;
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  transition: all 0.3s ease;
  transform: ${props => props.showComments ? 'scale(0.5)' : 'scale(0.9)'};

  @media (max-width: 768px) {
    max-width: 350px;
    transform: ${props => props.showComments ? 'scale(0.55)' : 'scale(1)'};
  }
`;

const DripTitle = styled.h1`
  color: #fff;
  font-size: 2rem;
  font-weight: 400;
  position: relative;
  text-align: center;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 3px;
    background-color: #fff;
    border-radius: 2px;
  }
  
  @media (max-width: 768px) {
    margin-top: 0px;
    font-size: 1.5rem;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 10px;
`;

const ActionButton = styled(motion.button)`
  background: var(--primary-gradient);
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 10px 16px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
  }
`;

const CommentsSection = styled(motion.div)`
  background: rgba(41, 41, 41, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 10px 20px 20px 20px;
  margin: 10px 20px 20px 20px;
  max-width: 600px;
  min-width: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  
  @media (max-width: 768px) {
    min-width: 90%;
    margin: 10px 10px 20px 10px;
    padding: 10px 15px 20px 15px;
  }
`;

const CommentsTitle = styled.p`
  color: #fff;
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  } 
`;

const CommentsList = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 200px;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`;

const CommentItem = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border-left: 3px solid var(--primary-color);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    transform: translateX(3px);
  }

  @media (max-width: 768px) {
    padding: 8px 10px;
    margin-bottom: 6px;
  }
`;

const CommentAuthor = styled.div`
  font-weight: 600;
  color: var(--primary-color);
  font-size: 0.7rem;
  margin-bottom: 3px;
`;

const CommentText = styled.div`
  color: #fff;
  font-size: 0.75rem;
  line-height: 1.2;
  margin-bottom: 4px;
  word-break: keep-all;
`;

const CommentStats = styled.div`
  display: flex;
  gap: 10px;
  font-size: 0.6rem;
  color: rgba(255, 255, 255, 0.7);

  span {
    display: flex;
    align-items: center;
    gap: 2px;
  }
`;

const SubmitSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 10px;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const SubmitText = styled.h3`
  color: #fff;
  font-size: 1.2rem;
  font-weight: 400;
  text-align: center;
  margin: 0;
`;

const SubmitButton = styled(motion.button)`
  background: var(--primary-gradient);
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 10px 16px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
  }
`;

const DripVideoWatch = ({ 
  currentVideo, 
  currentVideoIndex, 
  totalVideos, 
  onVideoEnd,
  comments = [],
  commentsLoading = false,
  onSubmit,
  onBack
}) => {
  const [showComments, setShowComments] = useState(true);

  if (!currentVideo) return null;

  const handleCommentsToggle = () => {
    setShowComments(!showComments);
  };

  const handleSubmit = () => {
    // 영상 링크를 새 탭에서 열기
    const videoUrl = `https://www.youtube.com/watch?v=${currentVideo.videoId}`;
    window.open(videoUrl, '_blank');
    
    // 결과 전달
    const result = {
      selectedVideoId: currentVideo.videoId,
      selectedVideoTitle: currentVideo.title,
      timestamp: new Date().toISOString()
    };
    
    onSubmit && onSubmit(result);
  };

  return (
    <DripLayout
      key={`video-${currentVideoIndex}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      showComments={showComments}
    >
      {/* <TitleArea>
        {onBack && (
          <ActionButton
            onClick={onBack}
            style={{
              position: 'absolute',
              left: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              padding: '8px 12px',
              fontSize: '0.9rem'
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            ‹ 뒤로
          </ActionButton>
        )}
        <DripTitle>
          {currentVideoIndex + 1}번 영상 ({currentVideoIndex + 1}/{totalVideos})
        </DripTitle>
      </TitleArea> */}
      
      <VideoArea showComments={showComments}>
        <VideoWrapper>
          <VideoContainer showComments={showComments}>
            <VideoPlayerIframe 
              videoUrl={`https://www.youtube.com/watch?v=${currentVideo.videoId}`}
              onVideoEnd={onVideoEnd}
              containerType="drip"
              showControls={false}
              loop={true}
            />
          </VideoContainer>
        </VideoWrapper>
      </VideoArea>

      {!showComments && (
        <ButtonArea>
          {onBack && (
            <ActionButton
              onClick={onBack}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                boxShadow: 'none',
                padding: '8px 16px',
                fontSize: '0.9rem'
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              ‹ 목록보기
            </ActionButton>
          )}
          <ActionButton
            onClick={handleCommentsToggle}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            💬 댓글보기
          </ActionButton>
        </ButtonArea>
      )}

      {showComments && (
        <>
          <CommentsSection
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px'}}>
            <CommentsTitle>💬 인기 댓글 TOP 20</CommentsTitle>
              {/* <ActionButton
                onClick={handleCommentsToggle}
                style={{
                  padding: '4px 8px',
                  fontSize: '0.8rem',
                  background: 'rgba(255, 255, 255, 0.1)',
                  minWidth: 'auto',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                ✕
              </ActionButton> */}
            </div>
            
            <CommentsList>
              {commentsLoading ? (
                <div style={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.6)', padding: '20px' }}>
                  댓글을 불러오는 중...
                </div>
              ) : comments.length > 0 ? (
                comments.map((comment) => (
                  <CommentItem key={comment.id}>
                    <CommentAuthor>{comment.author}</CommentAuthor>
                    <CommentText>{comment.text}</CommentText>
                    <CommentStats>
                      <span>👍 {comment.likes.toLocaleString()}</span>
                      <span>💬 {comment.replies}</span>
                    </CommentStats>
                  </CommentItem>
                ))
              ) : (
                <div style={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.6)', padding: '20px' }}>
                  제일 먼저 드립 치고 응모하세요!
                </div>
              )}
            </CommentsList>
          </CommentsSection>

          <SubmitSection>
            {/* <SubmitText>드립 하나로 인생 갈린다.</SubmitText> */}
            {onBack && (
              <ActionButton
                onClick={onBack}
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  boxShadow: 'none',
                  padding: '8px 16px',
                  fontSize: '0.9rem'
                }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                ‹ 목록보기
              </ActionButton>
            )}
            <SubmitButton
              onClick={handleSubmit}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {currentVideo.isDrip ? '드립치고 응모하기' : '응원하고 응모하기'}
            </SubmitButton>
          </SubmitSection>
        </>
      )}
    </DripLayout>
  );
};

export default DripVideoWatch; 